import { listFixtures } from "@/lib/api/client";
import type { FixturePage, FixtureQuery } from "@/lib/api/types";

/** Formatted in UTC rather than the reader's zone, deliberately.
 *
 * This used to be a server-only module and the fixed timezone was there to stop
 * a hydration mismatch. There is no server render left to mismatch, but the
 * choice stands on its own: a fixture's scheduled time means the same thing to
 * everyone looking at it, and a scorer in one timezone reading a different
 * clock from a scorer in another is a support ticket, not a feature. */
const WHEN = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "UTC",
});

export const FIXTURES_PAGE_SIZE = 25;

/** One page of fixtures, ready to render. */
export async function loadFixtures(query: FixtureQuery = {}): Promise<FixturePage> {
  const page = await listFixtures({ limit: FIXTURES_PAGE_SIZE, ...query });
  return {
    total: page.total,
    rows: page.rows.map((row) => ({
      ...row,
      startsLabel: row.scheduledStart ? WHEN.format(new Date(row.scheduledStart)) : null,
    })),
  };
}
